import React from "react";
// @ts-ignore
import ComboSelect from "./ComboSelect";
import {useState} from "react";
// @ts-ignore
import {_} from "../../../vendor";

const MultiSelectWithContextMenu = (props:any) => {
    const {values, options, label, name, extraClass, disabled, required, helpMessage, onChange, onRemove, amounts,contextFunctions} = props;
    const [results, setResults] = useState(values);
    const [current, setCurrent] = useState(null);

    const MENU_ID = _.uniqueId;
    const go = (e:any,id:any,name:any) => {
        console.log('go',[name,id]);
        contextFunctions(name,id);
       return true;
    }
    const onContext = (e:any) => {
        e.preventDefault();
        let element = e.target.parentNode;
        if(element.id !== "") {
            setCurrent(element.id);
            const existingPopups = document.getElementsByClassName('inb-c-popup-window');
            let element2 = element.parentNode.parentNode.parentNode.parentNode;
            element2.classList.add('select2-container--focus');
            while (typeof element !== 'undefined') {

                let id = e.currentTarget.attributes._id;
                let title = e.currentTarget.attributes.title;
                let htmlContext =
                    '<ul style="list-style-type: none;width:100%;margin: 5px;margin-bottom: 10px;display:block;">';

                options.map((option: any) => {
                    htmlContext += '<li o_id="'+element.id+'" o_ob="'+option.id+'" o_on="'+option.onClick+'" style="min-height:0;" class="context_menu_item" id="' + option.id + '" onClick="go()">' + option.label + '</li>';
                })

                htmlContext += '</ul>';
                // open popup to copy code to clipboard
              /*  if (existingPopups.length === 0 && false === true) {
                    let popup = document.createElement('div');
                    let info = document.createElement('div');
                    info.style.display = 'none';
                    info.innerHTML = e.target.title;
                    info.className = 'inb-c-popup-info';
                    popup.className = "inb-c-popup-window";
                    popup.innerHTML = htmlContext;
                    popup.appendChild(info);
                    popup.style.left = e.pageX + 5 + 'px';
                    popup.style.top = e.pageY - 25 + 'px';
                    document.body.appendChild(popup);
                 /*   options.map(option => {
                        let elem = document.getElementById(option.id);

                        elem.addEventListener("click", e => go(e,element.id,option.onClick));
                        console.log(elem)
                    });

                } else {*/
               /*     existingPopups[0].style.left = e.pageX + 5 + 'px';
                    existingPopups[0].style.top = e.pageY - 25 + 'px';
                }*/
                break;

            }
        }
    }

    return (
        <>
            <label className={"inb-form__controlLabel"}>{label}</label>
           <ComboSelect
               onClickedHandler={onChange}
               onRemoveHandler={onRemove}
               onItemSearchChanged={null}
               onItemSearchBlur={null}
               itemResultsHidden={values}
               onItemsSelectHandle={setResults}
               selectedItems={values}
               allItems={values}
               valkey={'value'}
               valprop={'label'}
               extraAmount={true}
               amountValue={amounts}
               short={true}
               placeholder={""}
               contextMenu={true}
               onContext={onContext}
               contextMenuItems={options}
               menuId={MENU_ID}
               contextFunctions={contextFunctions}
               />
            {typeof helpMessage !== 'undefined' && <><span className="help-text">{helpMessage}</span></>}
        </>
    )
}
export default MultiSelectWithContextMenu;

